import { render, staticRenderFns } from "./MarketingStatistics.vue?vue&type=template&id=c175cc28&scoped=true"
import script from "./MarketingStatistics.vue?vue&type=script&lang=js"
export * from "./MarketingStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c175cc28",
  null
  
)

export default component.exports